import React from 'react';
import { styled } from '@mui/system';
import { colors } from '../theme/index.js';

/**
 * 
 * @returns 
 */
const ModalFilePreview = /*#__PURE__*/React.forwardRef((props, ref) => {
  const customStyle = props.customStyle;
  const StyledDiv = styled('div')(({
    theme
  }) => ({
    minHeight: '315px',
    minWidth: '285px',
    backgroundColor: colors.surface,
    borderRadius: '8px',
    padding: '10px',
    marginLeft: '5px',
    margin: '5px',
    wordBreak: 'break-all',
    [theme.breakpoints.down('666')]: {
      minWidth: 'fit-content'
    },
    ...customStyle
  }));
  const children = props.children;
  return /*#__PURE__*/React.createElement(StyledDiv, props, children);
});
export default ModalFilePreview;